"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDataToCookie = exports.removeCookieByName = exports.removeAllCookie = exports.getDataFromCookieAToB = exports.getDataFromCookie = exports.encryptData = exports.decryptData = void 0;
const encryptData = value => {
  return window.btoa(escape(encodeURIComponent(JSON.stringify(value))));
};
exports.encryptData = encryptData;
const decryptData = value => {
  return decodeURIComponent(unescape(window.atob(value)));
};
exports.decryptData = decryptData;
const setDataToCookie = (key, value, exp = 0, shouldEncrypt = true) => {
  const encryptValue = shouldEncrypt ? encryptData(value) : value;
  if (exp !== 0) {
    const d = new Date();
    d.setTime(d.getTime() + exp * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = key + '=' + encryptValue + ';' + expires + ';path=/';
  } else {
    document.cookie = key + '=' + encryptValue + ';' + ';path=/';
  }
};
exports.setDataToCookie = setDataToCookie;
const getDataFromCookie = key => {
  const encryptData = getCookieValue(key);
  let cookieValue = false;
  try {
    cookieValue = JSON.parse(decryptData(encryptData));
  } catch (_e) {
    // console.error('You can pass this value to your log tools');
  }
  return cookieValue;
};
exports.getDataFromCookie = getDataFromCookie;
const getDataFromCookieAToB = key => {
  const encryptData = getCookieValue(key);
  let cookieValue = false;
  try {
    cookieValue = atob(encryptData);
  } catch (_e) {
    // console.error('You can pass this value to your log tools');
  }
  return cookieValue;
};
exports.getDataFromCookieAToB = getDataFromCookieAToB;
function getCookieValue(cname) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
const removeAllCookie = () => {
  const allCookies = document.cookie.split(';');
  // The "expire" attribute of every cookie is
  // Set to "Thu, 01 Jan 1970 00:00:00 GMT"
  for (let i = 0; i < allCookies.length; i++) {
    document.cookie = allCookies[i] + '=;expires=' + new Date(0).toUTCString() + ';path=/;';
  }
};
exports.removeAllCookie = removeAllCookie;
const removeCookieByName = name => {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT ;path=/;';
};
exports.removeCookieByName = removeCookieByName;